import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconChevronDownSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.293 5.293a1 1 0 0 1 1.414 0L8 8.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
